import {Link, useNavigate} from 'react-router-dom';
import '../styles/layout/header.css';
import {useEffect, useState} from 'react';
import {BASE_URL} from '../Config';
import Button from './Button';

const Header = () => {
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userState, setUserState] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleLogin = () => {
            const storedUser = localStorage.getItem('user');
            if (storedUser) {
                const parsed = JSON.parse(storedUser);
                setIsLoggedIn(true);
                setUserState(parsed.state); // ← 상태 저장 (R, Y 등)
            } else {
                setIsLoggedIn(false);
                setUserState(null);
            }
        };

        handleLogin(); // 첫 진입 시 실행
        window.addEventListener('login', handleLogin); // 커스텀 이벤트로 로그인 반영

        return () => window.removeEventListener('login', handleLogin);
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('user');
        setIsLoggedIn(false);
        setUserState(null);
        navigate('/login');
    };

    const excelDownload = () => {
        window.open(`${BASE_URL}/download/users`, '_blank');
    };

    return (
        <header className="header">
            <Link to="/">
                <img
                    src="/assets/images/daedeok-logo.svg"
                    alt="logo"
                    className="header-logo"
                />
            </Link>

            <div className="hamburger" onClick={() => setIsMobileMenuOpen(true)}>
                <img src="/assets/icons/mobile-menu.svg" alt="Mobile Menu"/>
            </div>

            {isMobileMenuOpen && (
                <>
                    <div
                        className="backdrop"
                        onClick={() => setIsMobileMenuOpen(false)}
                    ></div>
                    <div className="mobile-menu">
                        <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>
                            현장정보등록
                        </Link>
                        <Link to="/userRegistration" onClick={() => setIsMobileMenuOpen(false)}>
                            USER정보등록
                        </Link>
                        <Link to="/nfcManagement" onClick={() => setIsMobileMenuOpen(false)}>
                            NFC등록관리
                        </Link>
                        <Link to="/recordInfo" onClick={() => setIsMobileMenuOpen(false)}>
                            기록정보확인
                        </Link>
                        {isLoggedIn ? (
                            <button
                                onClick={() => {
                                    handleLogout();
                                    setIsMobileMenuOpen(false);
                                }}
                            >
                                로그아웃
                            </button>
                        ) : (
                            <Link to="/login" onClick={() => setIsMobileMenuOpen(false)}>
                                로그인
                            </Link>
                        )}

                        <a href="/assets/images/qrcode_ddpartners.png" download="qrcode.png" className="qr-button">QR
                            이미지 다운</a>

                    </div>

                </>
            )}
        </header>
    );
};

export default Header;
